"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKELETON_BASE_COLOR = exports.SKELETON_HIGHLIGHT_COLOR = void 0;
var asg_1 = require("@alinta-digital/asg");
exports.SKELETON_HIGHLIGHT_COLOR = '#ECECEC';
exports.SKELETON_BASE_COLOR = asg_1.colors['grey-2'];
//# sourceMappingURL=Constants.js.map